import { useEffect, useState } from "react";
import { listSalesDeskDeals } from "./salesDeskDeals";
import { salesDeskLotSaleNameLabel, type SalesDeskLotUnit } from "./salesDeskLotFilter";

export function useSalesDeskLot(): {
  units: SalesDeskLotUnit[];
  loading: boolean;
  error: string | null;
} {
  const [units, setUnits] = useState<SalesDeskLotUnit[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await listSalesDeskDeals();
      if (cancelled) return;
      if (!result.ok) {
        setError(result.error);
        setUnits([]);
        setLoading(false);
        return;
      }
      setUnits(
        result.deals.flatMap((deal) => {
          const serial = deal.serial?.trim() ?? "";
          if (!serial) return [];
          return [
            {
              id: deal.id,
              serial,
              display_label: serial,
              origin: deal.productName,
              notes: "",
              intake_form_status: null,
              salePathLabel: salesDeskLotSaleNameLabel(deal.saleName),
            },
          ];
        }),
      );
      setError(null);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { units, loading, error };
}
